// extracted by mini-css-extract-plugin
module.exports =  {"icon":"_1c9529d521--icon--Hy4vL","icon--opened":"_1c9529d521--icon--opened--R5hx2"};